import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Paper } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
//import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { H3, H4, Button, ProgressBar, Dialog } from '@blueprintjs/core';
import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, FRONT_USER_ROLE_COOKIE_NAME } from '../../../auth/constants';
import Tree from "../concord/Tree.js";
import Meta from "../concord/Meta.js";
import "./Read.css";
import TextSelector from 'text-selection-react';

class Read extends React.PureComponent {

  state = {
    data:{
      pageContent:null,
      alignedPageContent:null,
      notEnoughRight:null,
      displayTree:false,
      waitingSuggestion:false
    },
  }
 
  // this function send a query to get the page that begins with sentNum 
  // or ends with sentNum-1 (if back is true)
  loadPage= (sentNum,back)=> {

    const postData = {
      sent_id: this.props.fileId+"_"+sentNum,
      back:back,
      collection: this.props.collection,
      lang: this.props.lang,
      aligned_language:this.props.alignedLang,
      extract_page:true,
      login: (Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME))? 
        Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME):"",
      role: (Cookies.get(FRONT_USER_ROLE_COOKIE_NAME))? 
        Cookies.get(FRONT_USER_ROLE_COOKIE_NAME):"",

    };

    const endpoint = '/get_result_meta.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((data) => {
          // Example of `data`:
          // {
          //   `metadata`,  // object, arbitrary key/value pairs
          //   `pageContent`,  // str
          //   `alignedPageContent`,  // str
          //   `firstNumSent`,  // int
          //   `lastNumSent`,  // int, syntax tree
          // }
          console.log(data);
          const m=data.metadata.docId.match(/#(\d+)#(\d+)/);
          if (m) {
            let firstPage=false;
            let lastPage=false;
            if (data.firstNumSent===parseInt(m[1])) {
              firstPage=true;
            }
            if (data.lastNumSent===parseInt(m[2])) {
              lastPage=true;
            }

            this.setState({ 
              data, 
              docFirstNum:parseInt(m[1]), 
              docLastNum:parseInt(m[2]),
              firstPage:firstPage,
              lastPage:lastPage,
              firstNumSent:data.firstNumSent,
              lastNumSent:data.lastNumSent
            } );
            //console.log("first:",parseInt(m[1]),"last:",parseInt(m[2]),firstPage,lastPage); 
          } else {
            // normally we should not be there because docId should always be there
            // this.setState({ data, firstPage:false, lastPage:false });
            console.log("Last document reached");
          }
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      }
    )
  }

  goPrec= () => {
    if (this.state.data.firstNumSent>1) {
      this.loadPage(this.state.data.firstNumSent-1,true);
    }
  }
  goNext= () => {
    this.loadPage(this.state.data.lastNumSent+1);
  }
  goPrecDoc= () => {
    if (this.state.data.firstNumSent>1) {
      this.loadPage(this.state.docFirstNum-1,true);
    }
  }
  goNextDoc= () => {
    this.loadPage(this.state.docLastNum+1);
  }

  componentDidMount() {
    // load the page that begins with sent_num
    this.loadPage(this.props.sentNum);
  };

  toggleModal = () => {
    this.setState(prevState => ({ displayTree: !prevState.displayTree}));
  }

  fetchTree = (selectedText) => {
    // building a temporary fileName for first temporary Result
    const tmpName=Date.now().toString()+"_"+Math.random(100).toString()+".json";
    // console.log("innerText=",selectedText.innerText);
    const data = {
      query: selectedText.innerText,
      fileId: this.props.fileId,
      collection: this.props.collection,
      language: this.props.lang,
      intervalSentNum: this.state.firstNumSent+"#"+this.state.lastNumSent,
      tmpName: tmpName,
      lemmatizeExample: false
    }; 
    if (this.props.params) {
      data.params = this.props.params;
    }

    this.setState({ treeQuery:selectedText.innerText, displayTree:true, waitingSuggestion:true });

    const endpoint = '/get_examples.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      }
    )
    .then((res) => {
      
      if (res.status !== 200) {
        console.log(`Issue reaching ${endpoint}`);
        this.setState({ waitingSuggestion:false });
        return;
      }
      res.json().then(data => {
        if (data.examples ) {
          if (data.examples.length>0 && data.examples[0].svg) {
            this.setState({ suggestion: data.examples[0].svg, displayTree:true, waitingSuggestion:false });
          } else {
            this.setState({ suggestion: "not found", displayTree:true, waitingSuggestion:false });
          }
          // console.log("trouvé");
        } else {
          this.setState({ waitingSuggestion:false });
          // console.log("pas trouvé");
        }
      }).catch(() => {
        // console.log('json pas lisible');
      })
    })
    .catch(() => {
      this.setState({ waitingSuggestion:false });
      console.log(`Network error when trying to fetch ${endpoint}`);
    })
  }

  render() {
    const {t} = this.props;
    const pageContent=this.state.data.pageContent;
    const firstPage=this.state.firstPage;
    const alignedPageContent=this.state.data.alignedPageContent;
    const notEnoughRight=this.state.data.notEnoughRight;
    const cl =  (alignedPageContent)? "flex-two-panels":"";
    const percent = Math.round((this.state.data.firstNumSent-this.state.docFirstNum)/(this.state.docLastNum-this.state.docFirstNum)*100);
    // console.log(this.state.firstNumSent+"#"+this.state.lastNumSent);
    //const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";
    return (
      <>
        { notEnoughRight &&
          <div>
            {t('noEnoughRight')}
          </div>
        }
        

        { (pageContent) &&
            <div className="flex meta">
  
              <div className="flex-one-third">
                <center>
                    <Button icon="double-chevron-left" onClick={this.goPrecDoc}>{t('docPrec')}</Button>&nbsp;
                    <Button rightIcon="double-chevron-right" onClick={this.goNextDoc}>{t('docNext')}</Button>
                    <br/> 
                    <Button icon="caret-left" onClick={this.goPrec}>{t('pagePrec')}</Button>&nbsp; 
                    <Button rightIcon="caret-right" onClick={this.goNext}>{t('pageNext')}</Button>
                    <br/>
                    <br/>
                    <div>Position : {percent}%</div>          
                </center>
               
                <Accordion defaultExpanded={true} >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <H3>{t('docMeta')}</H3>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Meta metadata={ this.state.data.metadata } />
                </AccordionDetails>
                </Accordion>
              </div>

              <div className="flex-two-third ">
                <Paper elevation={3} className="page">
                  <TextSelector
                   events={[
                      {
                        text:t('displayTree'),
                        handler: this.fetchTree
                      }
                    ]}
                  />
                    <div className={cl} >
                      { (firstPage) &&
                        <H4>{this.state.data.metadata.title}</H4>
                      }
                      <span dangerouslySetInnerHTML={{__html:pageContent.replace(/\n|\\n/g,"<br/>")}}></span>
                    </div> 
                  
                  { !!(alignedPageContent) &&
                    <div className={cl+" aligned"}>
                      <span dangerouslySetInnerHTML={{__html:alignedPageContent.replace(/\n|\\n/g,"<br/>")}}></span>
                    </div>
                  }
                  
                </Paper>
              </div>
          </div>
        }
        <Dialog
          scroll={'body'}
          isOpen={this.state.displayTree}
          onClose={this.toggleModal}
          title={this.state.treeQuery}
          style={{'width':'auto'}}
        > 
          { this.state.waitingSuggestion &&
            <ProgressBar/>
          }
          { ! this.state.waitingSuggestion &&
            <Tree svg={this.state.suggestion} />
          }
        </Dialog>
    </>
    )
  }
}

Read.propTypes = {
  fileId: PropTypes.string,
  sentNum: PropTypes.string,
  collection: PropTypes.string,
  lang: PropTypes.string,
  alignedLang: PropTypes.string,
  back: PropTypes.string,
};

export default withTranslation()(Read);
